import { render, staticRenderFns } from "./email-notifications-picker.vue?vue&type=template&id=8b4bed40&"
import script from "./email-notifications-picker.vue?vue&type=script&lang=ts&"
export * from "./email-notifications-picker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports